<template>
  <q-page padding>
    <div class="q-display-1 q-my-md text-secondary">
      <q-icon name="far fa-shopping-cart" class="q-mb-sm" /> Resgates
    </div>

    <q-tabs
      v-model="tab"
      class="text-primary"
      align="center"
    >
      <q-tab slot="title" name="PendingRewards" label="Resgates Pendentes" />
      <q-tab slot="title" name="RedeemHistory" label="Histórico de Resgates" />

      <q-tab-pane name="PendingRewards">
        <pending-rewards />
      </q-tab-pane>
      <q-tab-pane name="RedeemHistory">
        <redeem-history />
      </q-tab-pane>
    </q-tabs>

  </q-page>
</template>

<script>
  import PendingRewards from './PendingRewards.vue';
  import RedeemHistory from './RedeemHistory.vue';

  export default {
    i18nOptions: { namespaces: ["custom", "rewards", "admin", "common", "users"] },

    name: 'Auditory',

    data () {
      return {
        tab: 'PendingRewards', // Define the default tab
      }
    },

    components: {
      PendingRewards,
      RedeemHistory
    },
  }
</script>